import { LayoutContainer } from '@petsmart-ui/sparky';

import type { LinkTilesProps } from '../types';
import Tile4Links from './Tile4Links';
import Tile4LinksMobile from './Tile4LinksMobile';
import './Tile4Links.scss';

export default function Tile4Wrapper(props: LinkTilesProps) {
    return (
        <LayoutContainer className="tile4-container">
            <Tile4Links {...props} />
            <Tile4LinksMobile {...props} />
        </LayoutContainer>
    );
}
